module.exports = __webpack_public_path__ + "static/media/2022-february-article.f3beb9ad.jpg";